<div class="container">
  <div class="container-color-A"></div>
  <div class="container-color-B"></div>
  
  <app-login-card-form></app-login-card-form>
</div>
